import moment from 'moment'
import theme from '../theme'

export default {
  data () {
    return {
      theme
    }
  },
  methods: {
    epochToStr (epoch, format) {
      return moment(epoch, 'x').format(format)
    }
  }
}
